function Guatemala({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1296)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M32 15.9998C32 9.6564 28.3085 4.1754 22.9565 1.5874V30.4121C28.3085 27.8241 32 22.3431 32 15.9998Z" fill="#338AF3"/>
  <path d="M0 15.9998C0 22.3431 3.69156 27.8241 9.0435 30.4121V1.5874C3.69156 4.1754 0 9.6564 0 15.9998Z" fill="#338AF3"/>
  <path d="M20.1812 18.7053L17.4758 16L20.051 13.4246L19.9343 12.0645L19.197 11.3271L16 14.5241L12.803 11.3271L12.0658 12.0645L11.9491 13.4246L14.5243 16L11.8188 18.7053L13.2946 20.181L16 17.4756L18.7055 20.181L20.1812 18.7053Z" fill="#ACABB1"/>
  <path d="M19.9352 12.0649L18.4595 13.5406C19.0889 14.1701 19.4783 15.0396 19.4783 16.0001C19.4783 17.9211 17.921 19.4784 16.0001 19.4784C14.0791 19.4784 12.5218 17.9211 12.5218 16.0001C12.5218 15.0396 12.9111 14.1701 13.5406 13.5406L12.0649 12.0649C11.0577 13.0719 10.4348 14.4633 10.4348 16.0001C10.4348 19.0738 12.9264 21.5653 16 21.5653C19.0736 21.5653 21.5652 19.0737 21.5652 16.0001C21.5652 14.4633 20.9423 13.072 19.9352 12.0649Z" fill="#6DA544"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Guatemala;
